/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import Tooltip from "@eisinc/MobiusOverrides/Tooltip/Tooltip";
import Info from "@eisinc/XDL/Icons/Info";
import Measure from "@eisinc/XDL/Icons/Measure";
import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductDetailsPageContext } from "@insite/content-library/Pages/ProductDetailsPage";
import Icon from "@insite/mobius/Icon/Icon";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    cutWireSettings: getSettingsCollection(state).cutWireSettings,
});

export interface ProductCutLengthStyles {
    cutLengthNotification?: TypographyProps;
}

const styles: ProductCutLengthStyles = {
    cutLengthNotification: {
        size: "15px",
        css: css`
            display: flex;
            align-items: center;
            width: 100%;
            margin-top: 15px;
        `,
    },
};

type ProductBadge = {
    DisplayName: string;
    Description: string;
    Image: string;
};

type Props = WidgetProps & HasProduct & ReturnType<typeof mapStateToProps>;

const ProductCutLengthMessage = ({ product, cutWireSettings }: Props) => {
    if (product?.isVariantParent || !cutWireSettings) {
        return null;
    }

    const showCutWireBadge = (cutWireSettings as any).enableCutWire === "True";
    let showCutLength = false;
    let badges: ProductBadge[] = [];

    if (product?.properties?.badges) {
        badges = product?.properties?.badges && JSON.parse(product.properties["badges"]);
        if (badges?.length > 0) {
            showCutLength = badges.some(badge => badge.DisplayName === "CUTTABLE") && showCutWireBadge;
        }
    }

    if (!showCutLength) {
        return null;
    }

    return (
        <Typography {...styles.cutLengthNotification}>
            <Icon src={Measure} size={16} color="text" />
            &nbsp;&nbsp;{translate("Add Cut Lengths in Cart")}&nbsp;&nbsp;
            <Tooltip
                text={siteMessage("Add_Cut_Lengths_in_Cart") as string}
            />
        </Typography>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(connect(mapStateToProps)(ProductCutLengthMessage)),
    definition: {
        displayName: "Product Cut Length Message",
        group: "Product Details",
        allowedContexts: [ProductDetailsPageContext],
    },
};

export default widgetModule;
